import React from "react";
import JournalTupeItemDoc from "../Layout/Journal/JournalTupeItemDoc";
export default function JsonFormRenderValue({ field, value }) {
  let renderValue = value;

  if (field.type === "timestamp") {
    let dt = new Date(value);
    renderValue = dt.toLocaleString();
  }
  if (field.type === "boolean") {
    renderValue = value ? "Да" : "Нет";
  }
  if (field.type === "document") {
    renderValue = <JournalTupeItemDoc id={value} />;
  }
  if (field.type === "subform") {
    renderValue = "wtf!&";
  }

  return renderValue;
}
